/* RESPONSIBLE TEAM: team-actions */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable ember/no-classic-classes */
import Controller from '@ember/controller';
import { oneWay } from '@ember/object/computed';

export default Controller.extend({
  queryParams: ['json', 'previewStyle', 'hideEditor'],
  componentsJson: oneWay('json'),
  hideEditor: false,
});
